import React, {Component} from 'react'
import PropTypes from "prop-types"
import {getExportOrdersReport} from "../../../services/api/apiOrdersReport"
import {CSVLink} from "react-csv"

class ExportData extends Component {
    state = {
        error: '',
        loading: false,
        dataExport: []
    }

    _exportOrders = async () => {
        this.setState({
            loading: true
        })

        const {filters} = this.props
        const cloneFilterExp = Object.assign({}, filters)

        try {

            const res =  await getExportOrdersReport(cloneFilterExp)

            await this.setState({
                dataExport: res.data
            })

            await this.csvLink.link.click()

        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }
    }

    render() {
        const {dataExport} = this.state

        return (
            <div className="ExportData ml-3">
                <button onClick={this._exportOrders} className="btn btn-primary">Export Orders</button>
                <CSVLink
                    data={dataExport}
                    filename="orders.csv"
                    className="hidden"
                    ref={(r) => this.csvLink = r}
                    target="_blank"/>
            </div>
        )
    }
}

ExportData.propTypes = {
    filters: PropTypes.object.isRequired
}

export default ExportData